export class ProformaStateFront {

    stateKey: string;
    state: string;
}
